import { useEffect, useState, useCallback } from 'react';

import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';

import DescriptionIcon from '@mui/icons-material/Description';
import WorkIcon from '@mui/icons-material/Work';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DownloadingIcon from '@mui/icons-material/Downloading';

import { theme } from '../../../theme';
import { jobsRef } from '../../../firebase';
import Chat from '../../components/chat';
import { isShowChatNotifications } from '../../../utils';
import { getUserInfo } from '../../../storage';
import FtmRequests from '../../ftmRequests/FtmRequests';
import useCustomNavigate from '../../../components/hooks/useCustomNavigate';
import Invoices from './Invoices';
import { downloadJobsheet } from '../service';

const NavBtn = ({ job_id, job_firebase_document_id }) => {
    const { navigateToCustom } = useCustomNavigate();
    const [unreadMessageCount, setUnreadMessageCount] = useState(0);

    const [showJobChat, setShowJobChat] = useState(false);
    const handleOpenJobChat = () => setShowJobChat(true);
    const handleCloseJobChat = () => setShowJobChat(false);

    const [showFtmRequest, setShowFtmRequest] = useState(false);
    const handleOpenFtmRequest = () => setShowFtmRequest(true);
    const handleCloseFtmRequest = () => setShowFtmRequest(false);

    const [showInvoices, setShowInvoices] = useState(false);
    const handleOpenInvoices = () => setShowInvoices(true);
    const handleCloseInvoices = () => setShowInvoices(false);

    const [downloadingJobsheet, setDownloadingJobsheet] = useState(false);

    const subscribeToJob = useCallback((jobId) => {
        if (!jobId) return;

        return jobsRef.doc(jobId).onSnapshot((doc) => {
            if (doc.exists) {
                setUnreadMessageCount(
                    doc.data()?.job_admin_unread_message_count ?? 0
                );
            }
        });
    }, []);

    useEffect(() => {
        const unsubscribe = subscribeToJob(job_firebase_document_id);

        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [job_firebase_document_id, subscribeToJob]);

    const openChatView = () => {
        try {
            isShowChatNotifications(job_id, "NEW_DIRECT_MESSAGE");
    
            // Get user info
            let user_info = getUserInfo();
            let ref = jobsRef.doc(job_firebase_document_id);
    
            ref.update({
                job_last_message_seen_user: user_info.admin_firebase_document_id,
                job_last_message_seen_user_timestamp: new Date().getTime()
            });

            handleOpenJobChat();
    
        } catch (error) {
            console.error("Error open chat documents:", error);
        }
    };

    const handleListItemClick = (link) => {
        navigateToCustom(link);
    };

    const handleJobsheetDownload = useCallback(
        async (type) => {
            setDownloadingJobsheet(true);
            try {
                await downloadJobsheet(job_id);
            } finally {
                setDownloadingJobsheet(false);
            }
        },
        [job_id]
    );

    return (
        <div className="col-lg-8 col-md-8 my-sm-auto ms-sm-auto me-sm-0 mx-auto mt-3">
            <div className="nav-wrapper position-relative end-0">
                <ul className="nav nav-pills nav-fill p-1" role="tablist">

                    <li className="nav-item">
                        <Button
                            className="nav-link mb-0 px-0 py-1 active"
                            startIcon={<DescriptionIcon />}
                            onClick={handleOpenInvoices}
                        >
                            INVOICE
                        </Button>
                    </li>

                    <li className="nav-item">
                        <Button
                            className="nav-link mb-0 px-0 py-1 active"
                            startIcon={downloadingJobsheet ? <DownloadingIcon /> : <WorkIcon/>}
                            onClick={handleJobsheetDownload}
                            disabled={downloadingJobsheet}
                        >
                            {downloadingJobsheet ? "Loading..." : "Jobsheet"}
                        </Button>
                    </li>

                    <li className="nav-item">
                        <Badge
                            badgeContent={unreadMessageCount}
                            color={theme.sidebar_notification_count_color}
                        >
                            <Button
                                className="nav-link mb-0 px-0 py-1 active"
                                startIcon={<QuestionAnswerIcon />}
                                onClick={openChatView}
                            >
                                CHAT
                            </Button>
                        </Badge>
                    </li>

                    <li className="nav-item">
                        <Button
                            className="nav-link mb-0 px-0 py-1 active"
                            startIcon={<NotificationsIcon />}
                            onClick={handleOpenFtmRequest}
                        >
                            REQUEST
                        </Button>
                    </li>

                </ul>
            </div>

            <Chat
                job_id = {job_id}
                job_firebase_document_id = {job_firebase_document_id}
                show = {showJobChat}
                handleClose = {handleCloseJobChat}
            />

            <FtmRequests
                job_id = {job_id}
                show = {showFtmRequest}
                handleClose = {handleCloseFtmRequest}
            />

            <Invoices job_id={job_id} show={showInvoices} handleClose={handleCloseInvoices}/>
        </div>
    );
};

export default NavBtn;